import { useMemo } from "react";
import { ICompany } from "../../models/ICompany";
import { useCompanyList } from "./useCompanyList";



export type IUseCompanyHook = (companyId: ICompany["id"]) => {
    data: ICompany | null;
    fetching: boolean;
};

export const useCompany: IUseCompanyHook = (id) => {

    const { data: companies, fetching } = useCompanyList();

    const data = companies.find((company) => company.id === id)

    if (companies.length && !data) console.warn("Failed to find company by id: ", id);

    const rawData = data || null;

    return useMemo(() => ({
        data: rawData,
        fetching,
    }), [rawData, fetching]);

};